const CARD_ITEMS = [
  { id: 1, title: '4K超清画质体验', desc: '最高支持4K分辨率播放，每一帧都清晰细腻，带来影院级视觉享受。', icon: 'ri-4k-line', bg: 'bg-primary-50' },
  { id: 2, title: '智能推荐算法', desc: '基于您的观看偏好，精准推荐你可能喜欢的影视内容，越看越懂你。', icon: 'ri-brain-line', bg: 'bg-accent-50' },
  { id: 3, title: '多设备无缝切换', desc: 'PC、手机、平板数据同步，随时随地接续上次观看进度。', icon: 'ri-device-line', bg: 'bg-secondary-50' },
  { id: 4, title: '极速加载不缓冲', desc: '多线CDN加速技术，无论身处何地都能享受流畅不卡顿的播放体验。', icon: 'ri-speed-line', bg: 'bg-primary-50' },
  { id: 5, title: '丰富的影视库', desc: '汇聚超过10万部影视资源，涵盖电影、剧集、综艺、动漫、纪录片等。', icon: 'ri-database-2-line', bg: 'bg-accent-50' },
  { id: 6, title: '每日更新不断', desc: '内容团队每日精选上新，热门大片第一时间同步上线，追剧不等待。', icon: 'ri-calendar-check-line', bg: 'bg-secondary-50' },
  { id: 7, title: '完全免费零门槛', desc: '无需注册无需付费，打开即看，让每个人都能平等享受高清观影乐趣。', icon: 'ri-vip-crown-line', bg: 'bg-primary-50' },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">平台优势</h2>
          <p className="text-sm text-foreground-500 mt-2">为什么选择51视频？</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {CARD_ITEMS.map((item, idx) => (
            <div
              key={item.id}
              className={`${idx === 0 ? 'lg:col-span-2 lg:row-span-2' : ''} ${item.bg} border border-background-200/40 rounded-xl p-5 md:p-6 hover:border-primary-200 transition-all cursor-pointer group`}
            >
              <span className="w-10 h-10 flex items-center justify-center bg-background-50 rounded-xl mb-4 group-hover:scale-110 transition-transform">
                <i className={`${item.icon} text-xl text-primary-600`}></i>
              </span>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}